import TagStatus from '@/app/shared_components/tags/TagStatus.vue';
import TagCount from '@/app/shared_components/tags/TagCount.vue';

export default {
  install(app) {
    app.component('TagStatus', TagStatus);
    app.component('TagCount', TagCount);
  },
};
